<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Questions</div>
              <q-btn
                class="q-ml-md"
                color="primary"
                text-color="white"
                no-caps
                @click="newDialog = true"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
                :loading="dataLoading"
                @click="loadData"
              >
              </q-btn>
              <q-space />
              <q-input
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 260px) !important"
                >
                  <datatable
                    :filter="search"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template slot="body-cell-rangeType" slot-scope="data">
                      <q-td :props="data.props">
                        <q-select
                          v-model="data.props.row.rangeType"
                          label="Range"
                          v-bind="siteCFG.fields.general"
                          :options="questionRangeTypes"
                          option-label="label"
                          option-value="value"
                          emit-value
                          map-options
                          dense
                          readonly
                          @input="updateQuestionRow(data.props.row)"
                        >
                        </q-select>
                      </q-td>
                    </template>
                    <template slot="body-cell-range" slot-scope="data">
                      <q-td :props="data.props">
                        <q-select
                          v-if="data.props.row.rangeType == 0"
                          v-model="data.props.row.range"
                          label="Range"
                          v-bind="siteCFG.fields.general"
                          :options="questionRangeOptions"
                          option-label="label"
                          option-value="value"
                          emit-value
                          map-options
                          dense
                          readonly
                          @input="updateQuestionRow(data.props.row)"
                        >
                        </q-select>
                        <div class="row">
                          <div class="col-6 q-px-xs">
                            <q-input
                              label="Min"
                              v-if="data.props.row.rangeType == 1"
                              v-bind="siteCFG.fields.general"
                              type="number"
                              readonly
                              dense
                              v-model="data.props.row.min"
                            ></q-input>
                          </div>
                          <div class="col-6 q-px-xs">
                            <q-input
                              label="Max"
                              v-if="data.props.row.rangeType == 1"
                              v-bind="siteCFG.fields.general"
                              type="number"
                              readonly
                              dense
                              v-model="data.props.row.max"
                            ></q-input>
                          </div>
                        </div>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog v-model="newDialog" persistent max-width="600px">
      <q-card v-if="newDialog" tile style="width: 600px; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Question</div>
            <q-space />
            <q-btn
              round
              flat
              icon="mdi-close"
              @click="
                newDialog = false;
                newFormData = {};
              "
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <questionTypeForm
            ref="newForm"
            @close="newDialog = false"
            @loadingStateChanged="(state) => (createLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.newForm.create()"
                :loading="createLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-plus-circle"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Add
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="viewDetailsDialog" persistent max-width="600px">
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="width: 600px; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Question</div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="close"> </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <questionTypeForm
            ref="editForm"
            :id="viewFormData.id"
            @close="close"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                color="primary"
                no-caps
                class="float-right"
              >
                <q-icon
                  name="mdi-content-save"
                  color="white"
                  class="q-mr-sm"
                  size="xs"
                ></q-icon>
                Save
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";
  import questionTypeForm from "@/components/questionTypes/questionTypeForm.vue";
  import moment from "moment";

  // import { Notify } from "quasar";

  export default {
    components: {
      datatable,
      questionTypeForm,
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
        gridData: "questionTypes/list",
        dataLoading: "questionTypes/listLoading",
        questionRangeOptions: "settings/questionRangeOptions",
        questionRangeTypes: "settings/questionRangeTypes",
      }),
    },
    data: () => ({
      // data-table
      columns: [
        {
          name: "questionName",
          label: "Question",
          align: "left",
          field: "questionName",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true,
        },
        {
          name: "name",
          label: "Name",
          align: "left",
          field: "name",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          format: (v) => (v ? "Y" : "N"),
        },
        {
          name: "email",
          label: "Email",
          align: "left",
          field: "email",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          format: (v) => (v ? "Y" : "N"),
        },
        {
          name: "mobile",
          label: "Mobile",
          align: "left",
          field: "mobile",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          format: (v) => (v ? "Y" : "N"),
        },

        {
          name: "rangeType",
          label: "Range Type",
          align: "left",
          field: "rangeType",
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "range",
          label: "Range",
          align: "left",
          field: "range",
          style:
            "min-width: 200px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "competition",
          label: "Competition",
          align: "left",
          field: "competition",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          format: (v) => (v ? "Y" : "N"),
        },
        {
          name: "competitor",
          label: "Competitor",
          align: "left",
          field: "competitor",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          format: (v) => (v ? "Y" : "N"),
        },
        {
          name: "teams",
          label: "Teams",
          align: "left",
          field: "teams",
          style:
            "min-width: 50px;max-width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
          format: (v) => (v ? "Y" : "N"),
        },
      ],
      search: "",

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,
    }),
    watch: {
      $route: function () {
        this.handleRoute();
      },
    },
    mounted() {
      this.loadData();
      this.handleRoute();
    },
    methods: {
      handleDoubleClick(row) {
        this.$router.push(`${this.$route.path}/${row.id}`);
      },
      loadData() {
        this.$store.dispatch("questionTypes/loadAll");
      },
      handleRoute() {
        if (this.$route.params.id) {
          this.viewFormData = { id: this.$route.params.id };
          this.$nextTick(() => {
            this.viewDetailsDialog = true;
          });
        } else {
          this.viewDetailsDialog = false;
        }
      },
      close() {
        this.$router.push("/management/questionTypes");
      },
    },
  };
</script>

<style lang="scss" scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }

  .formHeight {
    min-height: calc(100vh - 175px);
    max-height: 1000px;
  }
</style>
